import { useApiQuery } from 'hooks/useApiQuery'
import { format } from 'date-fns'
const path = '/le-connect/reports/credits-wagered-hourly-trends'
const method = 'get'

interface UseGetCreditsWageredHourlyTrendsParams {
  licensedEstablishmentId: number | undefined
  startDate: Date
  endDate: Date
  enabled: boolean
}

const formatDate = (d: Date) => format(d, 'yyyy-MM-dd')

export const useGetCreditsWageredHourlyTrends = ({
  licensedEstablishmentId,
  startDate,
  endDate,
  enabled,
}: UseGetCreditsWageredHourlyTrendsParams) =>
  useApiQuery({
    path,
    method,
    queryKey: [
      path,
      licensedEstablishmentId,
      startDate.getTime(),
      endDate.getTime(),
    ],
    queryArgs: {
      licensedEstablishmentId,
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
    },
    enabled,
  })
